<template>
  <div class="group-game-container tournaments-holder">

    <template v-if="!displayOfferLoading && !outrightsLoading">
       <div v-if="isMobile && selectedMatch != null">
        <SportSingle
        v-if="selectedMatch.type === 'sport'"
        :outrightsIn="outrightsIn" />
        <OutrightSingle
        v-else-if="selectedMatch.type === 'outright'"
        type="sport"
        :selectedOutrightId="selectedMatch.id"
        :outright="findOutright" />
        </div>
        <div v-show="((smallDesktop && !selectedMatch) || !smallDesktop)">

            <div class="group-game empty" v-if="offerLoadingError" @click.stop="$emit('reloadoffer')">
                <div class="error-offer-loading">
                    <img class="odd-stats-img" src="../../../assets/img/error-offer-loading.svg" alt="offer-error">
                    <p>{{$t('OFFERLOADINGERROR')}}</p>
                </div>
            </div>

            <div class="group-game empty" v-else-if="showNoOffer">
                <div class="error-offer-loading">
                    <p v-if="sportState == 'prematch'">{{$t('NOSPORTOFFERAVAILABLEFORSELECTEDEFILTERS')}}</p>
                    <p v-if="sportState == 'live'">{{$t('NOLIVEOFFERAVAILABLE')}}</p>
                </div>
            </div>

            <template v-else>
                <div class="group-game" >
                    <DynamicScroller :buffer="lastTopScroll !== null ? lastTopScroll : 200"  :items="currentTournaments" :min-item-size="50" key-field="tournamentId" class="tournaments-scroller" ref_testcafe="tournamentContainer">
                        <template v-slot="{ item, index, active }">
                            <DynamicScrollerItem :item="item" :active="active" :size-dependencies="[item.marketsSelected, item.matches]" :data-index="index" :ref_testcafe="`dataIndex${[index]}`">
                            <!-- DynamicScrollerItem :item="item" :active="active" :data-index="index" -->
                                <OutrightTournaments
                                v-if="sportState == 'prematch' && (globals && globals.publicConfig && globals.publicConfig.verticalsAvailable && globals.publicConfig.verticalsAvailable.outrights )&& item.type && item.type === 'outrights'"
                                :key="item.tournamentId"
                                type="sport"
                                :singleOutrightTournament="item" />
                                <TournamentSingle
                                v-else
                                :item="item"
                                :key="item.tournamentId"
                                :matchesIn="matchesIn"
                                :outrightsIn="outrightsIn"
                                :tournamentActive="active"
                                :sportMapping="sportMapping"
                                :chunkCount="chunkCount"
                                :showOddStats="showOddStats"
                                @openMarkets="openMarkets"
                                @selectMatch="selectMatch"
                                 @favouritetoggled="favouritetoggled"
                                />
                            </DynamicScrollerItem>
                        </template>
                    </DynamicScroller>
                    <template v-if="selectedTourGroup && selectedTourGroupMarkets.length">
                        <div class="backdrop active" @click="selectedTourGroup = null"></div>
                        <div class="modal active modalTicketAnimation">
                            <div class="ddselect-content dropdown-market">
                                <div class="dropdown-market-header">
                                    <p>{{sportTree.categories[sportTree.tournaments[selectedTourGroup].categoryId].categoryName
                                        + ' --- '
                                        + sportTree.tournaments[selectedTourGroup].tournamentName}}</p>
                                    <div class="modal-close" @click="selectedTourGroup = null">
                                        <i class="iconset icon-close"></i>
                                    </div>
                                </div>
                                <div class="ddselect-content-list">
                                    <div class="ddselect-item" @click.prevent="selectMarket(null)">
                                        <label class="label">
                                            <input class="input-checkbox full" type="checkbox" :checked="selectedTourGroupMarkets.length == tournamentMapping[selectedTourGroup].marketsSelected.length">
                                            <span class="checkmark"></span>
                                            <span class="dropdown-text">{{$t('ALL')}}</span>
                                        </label>
                                    </div>
                                    <div class="ddselect-item" v-for="market in selectedTourGroupMarkets" :key="market.marketId" @click.prevent="selectMarket(market.marketId)">
                                        <label class="label">
                                            <input class="input-checkbox full" type="checkbox" :checked="tournamentMapping[selectedTourGroup].marketsSelected.indexOf(parseInt(market.marketId)) !== -1">
                                            <span class="checkmark"></span>
                                            <span class="dropdown-text">{{getMarketName(market.marketId, 'marketSelectorTab')}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </template>
</div>

</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';
import moment from 'moment-timezone';
import TournamentSingle from './TournamentSingle.vue';
import SportSingle from './SportSingle.vue';
import OutrightTournaments from './OutrightsTournaments.vue';
import OutrightSingle from './OutrightsSingle.vue';
import { isEmptyObject } from '../../helpers';

export default
{
    name: 'Tournaments',
    props: [
        'matchesIn',
        'sportsselected',
        'categoryselected',
        'tournamentselected',
        'favourites',
        'outrightsIn',
    ],
    data()
    {
        return {
            matchGroups: {},
            selectedTourGroup: null,
            lastTopScroll: null,
            tournamentsList: [],
            tournamentMapping: {},
            selectedTourGroupMarkets: [],
            lastOfferStructChangeTimestamp: null,
            initOfferFetchDone: false,
        };
    },
    components:
    {
        TournamentSingle,
        SportSingle,
        OutrightTournaments,
        OutrightSingle,
    },
    created()
    {
        if (this.sportTree.sports !== undefined)
        {
            this.reloadTournamentsList();
        }
    },
    methods:
    {
        ...mapActions(
            {
                selectEvent: 'selectEvent',
                selectMatchInit: 'selectMatch',
                selectMatches: 'selectMatches',
                checkRemoveMatch: 'checkRemoveMatch',
            },
        ),
        selectMarket(marketId)
        {
            const tour = this.selectedTourGroup;
            let marketsSelected = [...this.tournamentMapping[tour].marketsSelected];

            if (marketId == null)
            {
                const groups = this.selectedTourGroupMarkets;

                if (marketsSelected.length > 1)
                {
                    marketsSelected = [parseInt(groups[0].marketId, 10)];
                }
                else
                {
                    for (const group of groups)
                    {
                        const index = marketsSelected.indexOf(parseInt(group.marketId, 10));
                        if (index === -1)
                        {
                            marketsSelected.push(parseInt(group.marketId, 10));
                        }
                    }
                }

                const forceRefresh = {};
                forceRefresh[tour] = tour;

                this.tournamentMapping[tour].marketsSelected = marketsSelected;

                this.reloadTournamentsList(forceRefresh);
                return;
            }

            const index = marketsSelected.indexOf(parseInt(marketId, 10)); // this is string so help me God i'll start killing people in this

            if (index === -1)
            {
                marketsSelected.push(parseInt(marketId, 10));
            }
            else
            {
                // at least one group should be specified
                if (marketsSelected.length === 1)
                {
                    return;
                }

                marketsSelected.splice(index, 1);
            }

            this.tournamentMapping[tour].marketsSelected = marketsSelected;

            this.reloadTournamentsList();
        },
        openMarkets(tournamentId = null)
        {
            this.selectedTourGroup = tournamentId;
            this.calculateMarkets();
        },
        async calculateMarkets()
        {
            const groups = [];
            const groupsById = {};
            const tournamentId = this.selectedTourGroup;

            if (tournamentId === null
            || this.tournamentMapping[tournamentId] == null)
            {
                return;
            }

            const matchIds = Object.keys(this.tournamentMapping[tournamentId].matches);

            const matches = await this.selectMatches(matchIds);

            for (const match of matches)
            {
                for (const outcome of match.outcomes)
                {
                    if (outcome.status !== 'active' && outcome.status !== 'block')
                    {
                        continue;
                    }
                    groupsById[outcome.markets[0]] = this.sportTree.markets[outcome.markets[0]];
                }
            }

            for (const marketId in groupsById)
            {
                if (!this.sportTree.markets[marketId]
                || this.sportTree.markets[marketId].isInOddCount == null
                || this.sportTree.markets[marketId].isInOddCount === 0)
                {
                    continue;
                }

                groups.push({
                    marketId,
                    orderNum: groupsById[marketId].orderNum,
                });
            }

            if (groups.length > 1)
            {
                groups.sort((a, b) => a.orderNum - b.orderNum);
            }

            this.selectedTourGroupMarkets = groups;
        },
        getPreselectedMarket(match)
        {
            let firstFound = null;

            if (this.sportTree.marketTree[match.sportId] !== undefined)
            {
                if (this.sportTree.marketTree[match.sportId].markets !== undefined
                && this.sportTree.marketTree[match.sportId].markets.length)
                {
                    for (const marketOut of this.sportTree.marketTree[match.sportId].markets)
                    {
                        if (marketOut.tags !== undefined
                        && marketOut.tags !== null
                        && marketOut.tags.indexOf('preselected') !== -1)
                        {
                            const marketId = parseInt(marketOut.marketId, 10);

                            if (firstFound == null)
                            {
                                firstFound = marketId;
                            }

                            for (const outcome of match.outcomes)
                            {
                                if (outcome.markets.indexOf(marketId) !== -1)
                                {
                                    return marketId;
                                }
                            }
                        }
                    }
                }
            }

            return firstFound;
        },
        getEventStructureData(data)
        {
            const { match, tournamentId } = data;

            let tournamentName = this.$t('UNDEFINEDTOURNAMENTNAME');
            let tournamentOrder = 10000;
            let tournamentSportOrder = 9999999;
            let sportOrder = 10000;
            let { sportId } = match;
            let { categoryId } = match;
            let categoryName = this.$t('UNDEFINEDCATEGORYNAME');

            let categoryOrder = 10000;
            let tournamentIdOut = match.tournamentId;
            let specialTournament = false;

            if (tournamentId === 'bonus1'
            || tournamentId === 'bonus2')
            {
                tournamentName = this.$t('BONUSONETOURNAMENTNAME');
                sportOrder = -100;
                categoryOrder = -100;
                tournamentOrder = -100;
                tournamentSportOrder = -100;
                sportId = 'bonus';
                categoryId = tournamentId;
                tournamentIdOut = tournamentId;
                categoryName = '';
                specialTournament = true;

                if (tournamentId === 'bonus2')
                {
                    sportOrder = -10;
                    categoryOrder = -10;
                    tournamentOrder = -10;
                    tournamentSportOrder = -10;

                    tournamentName = this.$t('BONUSTWOTOURNAMENTNAME');
                }
            }
            else
            {
                tournamentName = this.$t('UNDEFINEDTOURNAMENTNAME');
                tournamentOrder = 10000;
                tournamentSportOrder = 9999999;
                if (this.sportTree.sports[match.sportId])
                {
                    sportOrder = this.sportTree.sports[match.sportId].sportOrder;
                }

                if (this.sportTree.tournaments[match.tournamentId] !== undefined)
                {
                    tournamentName = this.sportTree.tournaments[match.tournamentId].tournamentName;
                    tournamentOrder = this.sportTree.tournaments[match.tournamentId].tournamentOrder;

                    if (this.sportTree.tournaments[match.tournamentId].tournamentSportOrder !== undefined
                    && this.sportTree.tournaments[match.tournamentId].tournamentSportOrder != null)
                    {
                        tournamentSportOrder = this.sportTree.tournaments[match.tournamentId].tournamentSportOrder;
                    }
                }

                if (this.sportTree.categories[match.categoryId] !== undefined)
                {
                    categoryOrder = this.sportTree.categories[match.categoryId].categoryOrder;
                    categoryName = this.sportTree.categories[match.categoryId].categoryName;
                }
            }

            return {
                tournamentName,
                tournamentOrder,
                tournamentSportOrder,
                sportOrder,
                categoryOrder,
                sportId,
                categoryId,
                tournamentId: tournamentIdOut,
                categoryName,
                specialTournament,
            };
        },
        checkMatchDates(data)
        {
            if (this.onFavourites)
            {
                return true;
            }

            const { matchId, startDate, endDate } = data;

            const match = this.matchesIn[matchId];

            if (match == null)
            {
                this.checkRemoveMatch({
                    matchId,
                });

                return false;
            }

            const matchUtcDate = moment.utc(match.matchDate).valueOf();

            if (matchUtcDate < startDate
            || matchUtcDate > endDate)
            {
                this.checkRemoveMatch(match);
                return false;
            }

            return true;
        },
        reloadTournamentsList()
        {
            let startDate;
            let endDate;

            let timezoneTemp = moment.tz.guess();

            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.localeSetup
            && this.globals.publicConfig.localeSetup.web
            && this.globals.publicConfig.localeSetup.web.timezone)
            {
                timezoneTemp = this.globals.publicConfig.localeSetup.web.timezone;
            }

            const startDateOut = moment
                .utc(this.startDate)
                .tz(timezoneTemp).format('YYYY-MM-DD');

            endDate = moment
                .utc(this.endDate)
                .tz(timezoneTemp).valueOf();

            if (['+3h', '+6h', '+12h'].indexOf(this.specialDate) !== -1)
            {
                startDate = moment.utc();
            }

            if (moment().format('YYYY-MM-DD') === startDateOut)
            {
                startDate = moment.utc();
            }
            else
            {
                startDate = moment(this.startDate).utc();
            }

            // TODO check startDate and endDate issues with yesterday's matches (e.g. 23:30) in today's offer

            if (this.sportState === 'live')
            {
                endDate = moment.utc();
                startDate = moment.utc().subtract(1, 'year');
            }
            else if (this.specialDate === '+3h')
            {
                endDate = moment.utc(startDate).add(3, 'h').format();
            }
            else if (this.specialDate === '+6h')
            {
                endDate = moment.utc(startDate).add(6, 'h').format();
            }
            else if (this.specialDate === '+12h')
            {
                endDate = moment.utc(startDate).add(12, 'h').format();
            }
            else if (this.specialDate === 'all')
            {
                endDate = moment
                    .utc(this.endDate)
                    .tz(timezoneTemp).format('YYYY-MM-DD');
            }

            startDate = startDate.valueOf();
            endDate = endDate.valueOf();

            let offerStructChanged = false;

            if (this.lastOfferStructChangeTimestamp != null
            && moment.utc().valueOf() !== this.lastOfferStructChangeTimestamp)
            {
                offerStructChanged = true;
            }

            if (isEmptyObject(this.currentMatchesByTournaments))
            {
                this.tournamentMapping = {};
            }
            else
            {
                const existingTournamentMappings = {};

                for (const tournamentId in this.currentMatchesByTournaments)
                {
                    if (!this.currentMatchesByTournaments[tournamentId])
                    {
                        continue;
                    }

                    existingTournamentMappings[tournamentId] = this.tournamentMapping[tournamentId];
                }
                this.tournamentMapping = existingTournamentMappings;
            }

            // eslint-disable-next-line guard-for-in
            for (const tournamentId in this.currentMatchesByTournaments)
            {
                if (!this.currentMatchesByTournaments[tournamentId])
                {
                    continue;
                }

                const tournament = this.tournamentMapping[tournamentId];

                if (tournament)
                {
                    tournament.matches = { ...tournament.matches, ...this.currentMatchesByTournaments[tournamentId] };

                    let updatedOrders = false;

                    for (const matchId of Object.keys(tournament.matches))
                    {
                        const datesCheckData = {
                            matchId,
                            startDate,
                            endDate,
                        };

                        if (!this.checkMatchDates(datesCheckData))
                        {
                            this.$delete(this.tournamentMapping[tournamentId].matches, matchId);
                            continue;
                        }

                        const match = this.matchesIn[matchId];

                        if (match)
                        {
                            if (!updatedOrders)
                            {
                                if (offerStructChanged)
                                {
                                    const structureData = this.getEventStructureData({
                                        match,
                                        tournamentId,
                                    });

                                    this.tournamentMapping[tournamentId] = {
                                        ...this.tournamentMapping[tournamentId],
                                        ...structureData,
                                    };
                                }

                                updatedOrders = true;
                            }
                        }
                    }
                }
                else
                {
                    if (isEmptyObject(this.currentMatchesByTournaments[tournamentId]))
                    {
                        this.$delete(this.tournamentMapping, tournamentId);
                        break;
                    }

                    if (this.sportState === 'live'
                        && (tournamentId === 'bonus1'
                        || tournamentId === 'bonus2'))
                    {
                        continue;
                    }

                    const matches = this.currentMatchesByTournaments[tournamentId];

                    let updatedOrders = false;

                    for (const matchId of Object.keys(matches))
                    {
                        const datesCheckData = {
                            matchId,
                            startDate,
                            endDate,
                        };

                        if (!this.checkMatchDates(datesCheckData))
                        {
                            continue;
                        }

                        const match = this.matchesIn[matchId];

                        if (!updatedOrders)
                        {
                            if (match == null)
                            {
                                continue;
                            }
                            const structureData = this.getEventStructureData({
                                match,
                                tournamentId,
                            });

                            let marketId = null;

                            if (tournamentId === 'bonus1'
                                || tournamentId === 'bonus2')
                            {
                                marketId = tournamentId;
                            }
                            else
                            {
                                marketId = this.getPreselectedMarket(match);
                            }

                            const tourOut = {
                                matches,
                                marketsSelected:
                                    [
                                        marketId,
                                    ],
                                ...structureData,
                            };

                            this.$set(this.tournamentMapping, tournamentId, tourOut);

                            updatedOrders = true;
                        }
                    }
                }
            }

            const tournamentsListOut = [];
            for (const tournamentId in this.tournamentMapping)
            {
                if (!this.tournamentMapping[tournamentId])
                {
                    continue;
                }

                let selectedForShow = false;

                if (!isEmptyObject(this.tournamentMapping[tournamentId].matches))
                {
                    if (this.tournamentselected.length)
                    {
                        if (this.tournamentselected[0] === this.tournamentMapping[tournamentId].tournamentId)
                        {
                            selectedForShow = true;
                        }
                    }
                    else if (this.categoryselected.length)
                    {
                        if (this.categoryselected[0] === this.tournamentMapping[tournamentId].categoryId)
                        {
                            selectedForShow = true;
                        }
                    }
                    else if (this.sportsselected.length)
                    {
                        if (this.sportsselected[0] === this.tournamentMapping[tournamentId].sportId
                            || this.sportsselected[0] === 'all')
                        {
                            selectedForShow = true;
                        }
                        else if (tournamentId === 'bonus1'
                            || tournamentId === 'bonus2')
                        {
                            let foundBonusMatch = false;
                            const matchesFound = {};

                            for (const matchId in this.tournamentMapping[tournamentId].matches)
                            {
                                if (this.tournamentMapping[tournamentId].matches[matchId] != null)
                                {
                                    const match = this.matchesIn[matchId];

                                    if (match && this.sportsselected[0] === match.sportId)
                                    {
                                        foundBonusMatch = true;
                                        matchesFound[matchId] = match.increment;
                                    }
                                }
                            }

                            if (foundBonusMatch)
                            {
                                tournamentsListOut.push({
                                    ...this.tournamentMapping[tournamentId],
                                    matches: matchesFound,
                                });

                                continue;
                            }
                        }
                    }

                    if (selectedForShow)
                    {
                        tournamentsListOut.push(this.tournamentMapping[tournamentId]);
                    }
                }
            }

            if (this.connectedOutrights != null)
            { // eslint-disable-next-line guard-for-in
                for (const id in this.connectedOutrights)
                {
                    const item = this.connectedOutrights[id];
                    const tournamentIds = [];
                    const categoryIds = [];
                    const sportIds = [];

                    let sportOrder = 9999999;
                    let categoryOrder = 9999999;
                    let tournamentOrder = 9999999;
                    const tournamentSportOrder = 9999999;

                    for (const outright of item.outrights)
                    {
                        for (const treeItem of outright.tree)
                        {
                            if (treeItem.connectionId != null)
                            {
                                if (treeItem.connectionType === 'tournament'
                                && !tournamentIds.includes(treeItem.connectionId)
                                && this.sportTree.tournaments[treeItem.connectionId])
                                {
                                    tournamentIds.push(treeItem.connectionId);
                                    tournamentOrder = this.sportTree.tournaments[treeItem.connectionId]
                                        .tournamentOrder - 1;
                                    const { categoryId } = this.sportTree.tournaments[treeItem.connectionId];
                                    categoryIds.push(categoryId);
                                    categoryOrder = this.sportTree.categories[categoryId].categoryOrder;
                                    const { sportId } = this.sportTree.categories[categoryId];
                                    sportIds.push(sportId);
                                    sportOrder = this.sportTree.sports[sportId].sportOrder;
                                }
                                else if (treeItem.connectionType === 'category'
                                && !categoryIds.includes(treeItem.connectionId)
                                && this.sportTree.categories[treeItem.connectionId])
                                {
                                    categoryIds.push(treeItem.connectionId);
                                    categoryOrder = this.sportTree.categories[treeItem.connectionId].categoryOrder - 1;
                                    const { sportId } = this.sportTree.categories[treeItem.connectionId];
                                    sportIds.push(sportId);
                                    sportOrder = this.sportTree.sports[sportId].sportOrder;
                                }
                                else if (treeItem.connectionType === 'sport'
                                && !sportIds.includes(treeItem.connectionId)
                                && this.sportTree.sports[treeItem.connectionId])
                                {
                                    sportIds.push(treeItem.connectionId);
                                    sportOrder = this.sportTree.sports[treeItem.connectionId].sportOrder - 1;
                                }
                            }
                        }
                    }

                    let passed = false;
                    if (this.tournamentselected.length)
                    {
                        if (tournamentIds.indexOf(this.tournamentselected[0]) !== -1)
                        {
                            passed = true;
                        }
                    }
                    else if (this.categoryselected.length)
                    {
                        if (categoryIds.indexOf(this.categoryselected[0]) !== -1)
                        {
                            passed = true;
                        }
                    }
                    else if (this.sportsselected.length)
                    {
                        if ((sportIds.indexOf(this.sportsselected[0]) !== -1) || (this.sportsselected[0] === 'all'))
                        {
                            passed = true;
                        }
                    }
                    else if (!this.sportsselected.length && this.$route.params.sportId === undefined)
                    {
                        passed = true;
                    }

                    if (passed)
                    {
                        item.sportOrder = sportOrder;
                        item.categoryOrder = categoryOrder;
                        item.tournamentOrder = tournamentOrder;
                        item.tournamentSportOrder = tournamentSportOrder;
                        tournamentsListOut.push(item);
                    }
                }
            }

            if (tournamentsListOut.length > 1)
            {
                this.sortTournamentList(tournamentsListOut);
            }

            this.tournamentsList = tournamentsListOut;
        },
        sortTournamentList(tournamentList)
        {
            tournamentList.stableSort((a, b) =>
            {
                if (a.sportOrder < b.sportOrder)
                {
                    return -1;
                }

                if (a.sportOrder > b.sportOrder)
                {
                    return 1;
                }

                if (a.tournamentSportOrder != null && b.tournamentSportOrder == null)
                {
                    return -1;
                }

                if (a.tournamentSportOrder == null && b.tournamentSportOrder != null)
                {
                    return 1;
                }

                if (a.tournamentSportOrder != null && b.tournamentSportOrder != null)
                {
                    if (a.tournamentSportOrder < b.tournamentSportOrder)
                    {
                        return -1;
                    }

                    if (a.tournamentSportOrder > b.tournamentSportOrder)
                    {
                        return 1;
                    }
                }

                if (a.categoryOrder < b.categoryOrder)
                {
                    return -1;
                }

                if (a.categoryOrder > b.categoryOrder)
                {
                    return 1;
                }

                if (a.tournamentOrder < b.tournamentOrder)
                {
                    return -1;
                }

                if (a.tournamentOrder > b.tournamentOrder)
                {
                    return 1;
                }

                return 0;
            });
        },
        selectMatch(matchId)
        {
            this.selectMatchInit({
                type: 'sport',
                id: matchId,
            });
            this.lastTopScroll = window.scrollY;
        },
        getPreselectedGroup(match)
        {
            let firstFound = null;

            if (this.sportTree.marketTree[match.sportId] !== undefined)
            {
                if (this.sportTree.marketTree[match.sportId].markets !== undefined
                && this.sportTree.marketTree[match.sportId].markets.length)
                {
                    for (const marketOut of this.sportTree.marketTree[match.sportId].markets)
                    {
                        if (marketOut.tags !== undefined
                        && marketOut.tags !== null
                        && marketOut.tags.indexOf('preselected') !== -1)
                        {
                            const marketId = parseInt(marketOut.marketId, 10);

                            if (firstFound == null)
                            {
                                firstFound = marketId;
                            }

                            for (const outcome of match.outcomes)
                            {
                                if (outcome.markets.indexOf(marketId) !== -1)
                                {
                                    return marketId;
                                }
                            }
                        }
                    }
                }
            }

            return firstFound;
        },
        getSortedGroups(tournamentGroup)
        {
            const markets = [];

            if (tournamentGroup.groups.bonus1)
            {
                markets.push({ marketId: 'bonus1' });
            }
            else if (tournamentGroup.groups.bonus2)
            {
                markets.push({ marketId: 'bonus2' });
            }
            else if (this.sportTree.marketTree[tournamentGroup.sportId] !== undefined)
            {
                if (this.sportTree.marketTree[tournamentGroup.sportId].markets !== undefined
                && this.sportTree.marketTree[tournamentGroup.sportId].markets.length)
                {
                    for (const market of this.sportTree.marketTree[tournamentGroup.sportId].markets)
                    {
                        if (tournamentGroup.groups[market.marketId])
                        {
                            markets.push(market);
                        }
                    }
                }
                markets.stableSort((a, b) =>
                {
                    const aMarkerOrder = a.orderNum;
                    const bMarkerOrder = b.orderNum;

                    if (aMarkerOrder < bMarkerOrder)
                    {
                        return -1;
                    }
                    if (aMarkerOrder > bMarkerOrder)
                    {
                        return 1;
                    }
                    return 0;
                });
            }

            const marketIds = markets.map((market) => market.marketId);

            return marketIds;
        },
        getMarketName(marketId, field = 'name')
        {
            let nameOut = 'not defined';
            let fieldOut = field;

            if (this.globals.publicConfig != null
            && this.globals.publicConfig.website != null
            && this.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && this.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field] != null)
            {
                fieldOut = this.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field];
            }

            if (this.sportTree.markets[marketId] != null
            && this.sportTree.markets[marketId][fieldOut] != null)
            {
                nameOut = this.sportTree.markets[marketId][fieldOut];
            }

            return nameOut;
        },
        scrollToTop()
        {
            this.lastTopScroll = null;

            window.scroll({
                top: 0,
            });
        },
        favouritetoggled(val)
        {
            if (this.onFavourites
            || this.offerLoading
            || this.sportState !== 'live')
            {
                return;
            }

            let nextScrollTop = window.pageYOffset;

            if (!val)
            {
                if (this.isMobile)
                {
                    nextScrollTop -= 114;
                }
                else
                {
                    nextScrollTop -= 58;
                }
            }
            else if (this.isMobile)
            {
                nextScrollTop += 114;
            }
            else
            {
                nextScrollTop += 58;
            }

            if (nextScrollTop < 0)
            {
                nextScrollTop = 0;
            }

            window.scroll({
                top: nextScrollTop,
            });
        },
    },
    watch:
    {
        offerLoading(loading)
        {
            this.initOfferFetchDone = true;
            if (!loading)
            {
                this.reloadTournamentsList();
            }
        },
        onFavourites()
        {
            this.reloadTournamentsList();

            this.scrollToTop();
        },
        sportState()
        {
            this.initOfferFetchDone = false;
        },
        sportTree()
        {
            this.lastOfferStructChangeTimestamp = moment.utc().valueOf();
        },
        selectedTourGroup()
        {
            this.selectedTourGroupMarkets = [];
        },
        isMobile(val, oldVal)
        {
            if (val !== oldVal)
            {
                this.reloadTournamentsList();
            }
        },
        sportsselected()
        {
            this.reloadTournamentsList();

            this.scrollToTop();
        },
        categoryselected()
        {
            this.reloadTournamentsList();

            this.scrollToTop();
        },
        tournamentselected()
        {
            this.reloadTournamentsList();

            this.scrollToTop();
        },
        selectedMatch(val, oldVal)
        {
            if (val == null
            && oldVal != null)
            {
                if (this.smallDesktop)
                {
                    if (this.lastTopScroll != null)
                    {
                        this.$nextTick(() =>
                        {
                            window.scroll({
                                top: this.lastTopScroll,
                            });
                            this.lastTopScroll = null;
                        });
                    }
                }
            }
        },
        matchesIn: {
            handler: function matchWatcher()
            {
                this.reloadTournamentsList();
            },
            deep: true,
        },
        connectedOutrights()
        {
            if (Object.keys(this.sportTree).length)
            {
                this.reloadTournamentsList();
            }
        },
    },
    computed:
    {
        ...mapGetters(
            [
                'selectedMatch',
                'sportTree',
                'sportState',
                'isMobile',
                'offerLoading',
                'startDate',
                'endDate',
                'globals',
                'offerLoadingError',
                'specialDate',
                'smallDesktop',
                'matchesByTournaments',
                'outrightsOfferLoading',
                'connectedOutrights',

            ],
        ),
        ...mapGetters('favourites', [
            'favouritesOnCurrentOffer',
            'favouriteMatchesByTournaments',
        ]),
        displayOfferLoading()
        {
            return !this.initOfferFetchDone || this.offerLoading;
        },
        outrightsLoading()
        {
            if (this.outrightsOfferLoading
                && this.globals.publicConfig
                && this.globals.publicConfig.verticalsAvailable
                && this.globals.publicConfig.verticalsAvailable.outrights
                && !this.connectedOutrights != null)
            {
                return true;
            }

            return false;
        },
        findOutright()
        {
            if (this.connectedOutrights == null)
            {
                // this.reloadTournamentsList();
                return false;
            }
            // eslint-disable-next-line guard-for-in
            for (const id in this.connectedOutrights)
            {
                // this.reloadTournamentsList();
                const item = this.connectedOutrights(id);
                if (item.outrights)
                {
                    for (const outright of item.outrights)
                    {
                        if (outright.outrightsOfferId === this.selectedMatch.id
                            && (outright.status === 'active'
                            && outright.status === 'block'))
                        {
                            return outright;
                        }
                    }
                }
            }

            return false;
        },
        showNoOffer()
        {
            return !this.currentTournaments.length && !this.offerLoading;
        },
        onFavourites()
        {
            return this.$route.params.mode === 'favourites';
        },
        currentMatchesByTournaments()
        {
            if (this.onFavourites)
            {
                return this.favouriteMatchesByTournaments;
            }
            return this.matchesByTournaments;
        },
        favouriteTournamentsList()
        {
            const favTournamentList = [];
            if (this.onFavourites)
            {
                for (const tournament of this.tournamentsList)
                {
                    if (tournament.type === 'outrights')
                    {
                        continue;
                    }

                    let hasMatch = false;
                    const intersectedMatches = {};

                    for (const favourite of this.favouritesOnCurrentOffer)
                    {
                        const match = tournament.matches[favourite.matchId];

                        if (match)
                        {
                            intersectedMatches[favourite.matchId] = match;
                            hasMatch = true;
                        }
                    }

                    if (hasMatch)
                    {
                        tournament.matches = intersectedMatches;
                        favTournamentList.push(tournament);
                    }
                }
            }
            return favTournamentList;
        },
        isLiveOffer()
        {
            return this.sportState === 'live';
        },
        getFavouritesTournamentStructure()
        {
            return {
                tournamentName: this.$t('FAVOURITES_TOURNAMENT_NAME'),
                tournamentOrder: -1000,
                tournamentSportOrder: -1000,
                sportOrder: -1000,
                categoryOrder: -1000,
                sportId: 'favourites',
                categoryId: 'favourites',
                tournamentId: 'favourites',
                categoryName: this.$t('FAVOURITES_CATEGORY_NAME'),
                specialTournament: true,
                marketsSelected: [
                    'favourites',
                ],
            };
        },
        currentTournaments()
        {
            if (this.onFavourites)
            {
                return this.favouriteTournamentsList;
            }

            if (this.isLiveOffer
            && this.favouritesOnCurrentOffer.length)
            {
                let hasMatches = false;

                const favouritesTournament = {
                    ...this.getFavouritesTournamentStructure,
                    matches: {},
                };

                for (const match of this.favouritesOnCurrentOffer)
                {
                    if (!this.sportsselected.length
                    || this.sportsselected[0] === 'all'
                    || this.sportsselected[0] === match.sportId)
                    {
                        hasMatches = true;

                        favouritesTournament.matches[match.matchId] = match;
                    }
                }

                if (hasMatches)
                {
                    return [
                        favouritesTournament,
                        ...this.tournamentsList,
                    ];
                }
            }

            return this.tournamentsList;
        },
        sportMapping()
        {
            let val = {};

            if (this.globals
            && this.globals.props
            && this.globals.props.sportMapping)
            {
                val = this.globals.props.sportMapping;
            }

            return val;
        },
        chunkCount()
        {
            let chunk = 6;

            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.maxChunkCount)
            {
                chunk = this.globals.publicConfig.website.maxChunkCount;
            }

            if (this.isMobile)
            {
                chunk = 100;
            }

            return chunk;
        },
        showOddStats()
        {
            return this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.betradarStatisticsUrl;
        },
        offerExists()
        {
            return this.currentTournaments.length;
        },
    },
};
</script>
